import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionRemindMeNudge = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    discountValue: string,
    bannerId: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMIND_ME_NUDGE,
        context: discountValue,
        label: bannerId,
    });
};

export const clickRemindMeLater = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    discountValue: string,
    bannerId: string,
) => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_REMIND_ME_NUDGE,
        context: discountValue,
        label: bannerId,
    });
};

export const impressionThankyouCrouton = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    bannerId: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_THANKYOU_FOR_SHOWING_INTEREST,
        label: bannerId,
    });
};

export const impressionResponseReceived = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    bannerId: string,
) => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_RESPONSE_RECEIVED,
        label: bannerId,
    });
};
